import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';
import { colorSeveridad } from '../../utils/HelpPreinforme';
import preinformeStyles from './preinformeStyles';

/**
 * Tarjeta de solo lectura de un elemento narrativo (oportunidad, fortaleza o
 * recomendación): título y cuerpo completo, sin truncar. Con `severidad`
 * marca el borde lateral con el color de `colorSeveridad`; con `numero`
 * muestra un distintivo numérico (el valor de `orden`, no la posición en la
 * lista). Ningún control de formulario.
 */
const NarrativaCard = ({ titulo, cuerpo, severidad, numero }) => {
    const classes = preinformeStyles();
    const tieneNumero = typeof numero === 'number' && Number.isFinite(numero);
    const estiloBorde = severidad !== null
        ? { borderLeftColor: colorSeveridad(severidad) }
        : undefined;

    return (
        <Paper className={classes.narrativaCard} style={estiloBorde}>
            <div className={classes.narrativaHeaderRow}>
                {tieneNumero && (
                    <span className={classes.narrativaBadge} aria-hidden="true">
                        {numero}
                    </span>
                )}
                <Typography className={classes.narrativaTitulo} component="h3">
                    {titulo}
                </Typography>
            </div>
            <Typography variant="body2" className={classes.narrativaCuerpo}>
                {cuerpo}
            </Typography>
        </Paper>
    );
};

NarrativaCard.propTypes = {
    titulo: PropTypes.string.isRequired,
    cuerpo: PropTypes.string.isRequired,
    severidad: PropTypes.number,
    numero: PropTypes.number,
};

NarrativaCard.defaultProps = {
    severidad: null,
    numero: null,
};

export default NarrativaCard;
